import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { FaTelegramPlane, FaWhatsapp, FaInstagram, FaEnvelope } from "react-icons/fa";
import "./Footer.css";
import api from "../../utils/api";

const Footer = () => {
  const [settings, setSettings] = useState({
    whatsappNumber: "",
    telegramLink: "",
    instagramLink: "",
    supportEmail: "",
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const { data } = await api.get("/frontend/site-settings");
        if (data.success && data.data) {
          setSettings(data.data);
        }
      } catch (error) {
        console.error("Failed to fetch settings", error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <footer className="site-footer">
      <Container>
        {/* Top Section: Brand & Navigation */}
        <Row className="gy-4 justify-content-between">
          {/* Brand Column */}
          <Col lg={5} md={6}>
            <div className="footer-brand">
              <h2 className="footer-logo">Ambe Worlds</h2>
              <p className="footer-text">
                Experience the ultimate online gaming platform.
                Secure, fast, and exciting trusted by millions.
              </p>
              <div className="footer-social-enhanced">
                {settings.telegramLink && (
                  <a href={settings.telegramLink} target="_blank" rel="noopener noreferrer" aria-label="Telegram" className="social-icon telegram">
                    <FaTelegramPlane />
                  </a>
                )}
                {settings.whatsappNumber && (
                  <a href={`https://wa.me/${settings.whatsappNumber}`} target="_blank" rel="noopener noreferrer" aria-label="Whatsapp" className="social-icon whatsapp">
                    <FaWhatsapp />
                  </a>
                )}
                {settings.instagramLink && (
                  <a href={settings.instagramLink} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="social-icon instagram">
                    <FaInstagram />
                  </a>
                )}
                {settings.supportEmail && (
                  <a href={`mailto:${settings.supportEmail}`} aria-label="Email" className="social-icon email">
                    <FaEnvelope />
                  </a>
                )}
              </div>
            </div>
          </Col>

          {/* Platform Links */}
          <Col lg={3} md={6} xs={6}>
            <h5 className="footer-heading">Platform</h5>
            <ul className="footer-links">
              <li><a href="/casino">Slots</a></li>
              <li><a href="/sports">Sportsbook</a></li>
              <li><a href="/live-casino">Live Casino</a></li>
            </ul>
          </Col>

          {/* Secure & Age */}
          <Col lg={4} md={12}>
            <h5 className="footer-heading">Secure Payments</h5>
            <div className="payment-icons mb-4">
              <span className="pay-badge">UPI</span>
              <span className="pay-badge">NetBanking</span>
              <span className="pay-badge">Visa</span>
              <span className="pay-badge">Mastercard</span>
              <span className="pay-badge">Bitcoin</span>
            </div>
          </Col>
        </Row>

        <hr className="footer-divider-premium" />

        {/* Bottom Section */}
        <Row className="align-items-center">
          <Col md={6} className="text-md-start text-center mb-3 mb-md-0">
            <p className="copyright-text">
              © 2026 <span className="text-highlight">Ambe Worlds</span>. All rights reserved.
            </p>
          </Col>
          {/* <Col md={6} className="text-md-end text-center">
            <p className="disclaimer-text">
              Gambling involves risk. Please play responsibly.
            </p>
          </Col> */}
          <Col md={6} className="text-md-end text-center">
            <div className="age-restriction-box">
              <span className="age-badge">18+</span>
              <span className="age-text"> only to play.</span>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
